import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useSecondaryModal } from 'utils';
import { httpRequestsOnSuccessActions } from 'store';

const ACTION_TYPE = 'SEND_FORM';

export const SupportModal = ({ platform = 'Staff Portal' }) => {
    const formContainerRef = useRef(null);
    const { closeSecondary } = useSecondaryModal();
    const dispatch = useDispatch();

    useEffect(() => {
        const originalTitle = document.title;
        // HubSpot records the page title + URL with every submission, so tagging
        // the title with the originating platform auto-labels which app the
        // ticket came from (Staff Portal / Members Portal / mobile) with no
        // HubSpot form reconfiguration.
        document.title = `Support Form — ${platform}`;

        const script = document.createElement('script');
        script.src = '//js.hsforms.net/forms/embed/v2.js';
        script.type = 'text/javascript';
        script.charset = 'utf-8';
        script.onload = () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: '48035702',
                    formId: '3cb43c52-1918-4d62-aa25-933b4fdc748d',
                    region: 'na1',
                    target: '#hubspot-form-container',
                    inlineMessage: true,
                    onFormSubmit: () => {
                        setTimeout(() => {
                            closeSecondary();
                            dispatch(httpRequestsOnSuccessActions.appendSuccess(ACTION_TYPE));
                        }, 100);
                    },
                });

                setTimeout(() => {
                    const iframe = document.querySelector('#hubspot-form-container iframe');
                    if (iframe) {
                        const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;
                        const submitButton = iframeDoc?.querySelector('input[type="submit"]');
                        if (submitButton) {
                            Object.assign(submitButton.style, {
                                backgroundColor: '#007bff',
                                color: '#fff',
                                width: '100%',
                                height: '48px',
                                padding: '10px 20px',
                                border: 'none',
                                borderRadius: '4px',
                                fontSize: '16px',
                                cursor: 'pointer',
                            });
                        }
                    }
                }, 500);
            }
        };

        document.body.appendChild(script);

        return () => {
            document.title = originalTitle;
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div style={{ width: 400, height: 350 }}>
            <div id="hubspot-form-container" ref={formContainerRef}></div>
        </div>
    );
};
